import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { useParentRoute } from '../../../../../global/hooks/useParentRoute';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { useEmploymentSetting } from '../../../components/use-employment-setting';
import { EmploymentState } from '../employment-model';
import { isUnpaidLeave } from '../employment-selector';
import { AddUnpaidLeaveForm } from './add-unpaid-leave-form';
import { AddUnpaidLeaveFormModel } from './add-unpaid-leave-form-models';
import { addUnpaidLeave } from './add-unpaid-leave-request';

export function AddUnpaidLeave() {

    const settings = useEmploymentSetting();
    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const dispatch = useDispatch();
    const parentRoute = useParentRoute();
	const unpaidLeave = isUnpaidLeave(employmentState?.currentEmployment);

	const lockedState = useLockedPageState(LockedPageKeys.Employment);

	const onSubmitHandler = (values: AddUnpaidLeaveFormModel) => {
		addUnpaidLeave(dispatch, employmentState?.currentEmployee?.id, values);
	};

	if (lockedState.isLocked || employmentState?.addUnpaidLeaveSuccess === ApiStatuses.Success || unpaidLeave) {
        return (<Redirect to={parentRoute} />);
	}

	return (
		<>
			<AddUnpaidLeaveForm
				formHeader={settings?.addUnpaidLeaveTitle}
				formDescription={settings?.addUnpaidLeaveDescription}
				onSubmitHandler={onSubmitHandler}
				employmentProps={settings}
				labelSettings={epiProps?.labelSettingState?.epiContent}
				employmentId={employmentState?.currentEmployment?.id}
                previousRoute={parentRoute}
			/>
		</>
	);
}